<div class="footer">
  <p class="mt-2">Dynery footer</p>
</div>